var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLobbytext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2406_212810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.3675,
    y: 12.3047,
    width: 75.907,
    height: 75.907,
    rx: 9.10884,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4103 57.0057V38.1133H31.6708V57.0057H29.4103Z",
    fill: "#0E4965"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.815 57.1676C36.7076 57.1676 33.8406 54.3068 33.8406 50.1234C33.8406 45.9401 36.7076 43.0793 40.815 43.0793C44.9225 43.0793 47.7895 45.9401 47.7895 50.1234C47.7895 54.3068 44.9225 57.1676 40.815 57.1676ZM40.815 55.1974C43.5993 55.1974 45.4739 53.0653 45.4739 50.1234C45.4739 47.1816 43.5993 45.0495 40.815 45.0495C38.0308 45.0495 36.1562 47.1816 36.1562 50.1234C36.1562 53.0653 38.0308 55.1974 40.815 55.1974Z",
    fill: "#0E4965"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0356 43.0793C60.9226 43.0793 63.7895 45.6433 63.7895 50.1234C63.7895 54.3338 60.9226 57.1676 57.0356 57.1676C54.6649 57.1676 53.066 56.223 52.2114 54.9005L51.9082 57.0057H49.9509V38.1133H52.2114V45.4543C53.1487 44.1858 54.6649 43.0793 57.0356 43.0793ZM56.8151 55.1974C59.5993 55.1974 61.4739 53.1192 61.4739 50.1234C61.4739 47.1277 59.5993 45.0495 56.8151 45.0495C54.0584 45.0495 52.1838 47.1277 52.1838 50.0695C52.1838 53.0923 54.0584 55.1974 56.8151 55.1974Z",
    fill: "#0E4965"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4026 57.0866L63.9168 43.2412H66.3151L70.6432 54.2258L74.8333 43.2412H77.2317L70.7534 59.3267C69.8713 61.5399 69.3475 62.4035 67.3627 62.4035H64.6611V60.3793H66.6735C67.9692 60.3793 68.1897 60.0555 68.7135 58.76L69.4026 57.0866Z",
    fill: "#0E4965"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2406_212810",
    x: 0.1861,
    y: 0.159573,
    width: 106.27,
    height: 106.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.03628
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5907
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2406_212810"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1386
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2406_212810",
    result: "effect2_dropShadow_2406_212810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2406_212810",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbytext);
export default __webpack_public_path__ + "static/media/Lobbytext.dc7e7bc734b8481c61c051c6be17b919.svg";
export { ForwardRef as ReactComponent };